const contactPerson = {
  phoneNumber: "0800 0008 327",
  email: "support@finanzierungsportal.ermoeglicher.de"
};

export default contactPerson;
